<template>
  <div class="mb-3">
    <div class="container-fluid">
      <div class="row" v-if="isMounted">
        <div class="col-12 customize-your-jewel pl-md-5">{{ $t('customize-your-jewel') }}</div>
        <div class="col-12 d-md-none">
          <div class="model-name">{{ $parent.currentJewelSelection.name }}</div>
          <div class="model-sku">{{ $parent.selectedSku }}</div>
          <div class="jewel-description">{{ $parent.jewelDescription }}</div>
          <div class="read-more">
            <span class="read-more-label" @click="readMore = !readMore">{{ $t('read-more-label') }}</span>
            <div v-if="readMore" class="read-more-value">
              {{ $t('read-more-ama-description') }}
            </div>
          </div>
        </div>
        <div class="col-md-5 text-left px-5 order-md-1 order-2">
          <div class="d-none d-md-block">
            <div class="model-name">{{ $parent.currentJewelSelection.name }}</div>
            <div class="model-sku">{{ $parent.selectedSku }}</div>
            <div class="jewel-description">{{ $parent.jewelDescription }}</div>
            <div class="read-more">
              <span class="read-more-label" @click="readMore = !readMore">{{ $t('read-more-label') }}</span>
              <div v-if="readMore" class="read-more-value">
                {{ $t('read-more-ama-description') }}
              </div>
            </div>
          </div>
          <div class="wholesale-price" v-if="!showOnlyPublicPrice">
            <span class="wholesale-price-label">{{ $t("wholesale-price") }}</span>
            <span class="wholesale-price-value">€ {{ $parent.priceValue }}</span>
          </div>
          <div class="retail-price">
            <span class="retail-price-label">{{ $t("retail-price") }}</span>
            <span class="retail-price-value">€ {{ $parent.averageOrVatPriceValue }}</span>
          </div>

          <!--Gold-->
          <div class="selector">
            <div class="selector-label">{{ $t("choose-gold-color") }}</div>
            <div class="selector-value">
              <div class="gold-circle" v-for="gold in settings.golds.slice().reverse()" :key="gold.id">
                <img :src="settings.baseImageUrl + gold.image" v-on:click="settings.triggerToChange(gold.id, '0')"
                  :style="{ border: settings.selectedGold == gold.id ? '2px solid' : '' }" />
              </div>
            </div>
          </div>

          <!--Measure-->
          <div class="selector" v-if="settings.sizes && settings.sizes.length > 0">
            <div class="selector-label">{{ $t("choose-measure") }}</div>
            <div class="selector-value">
              <select class="select-setting" @change="settings.triggerToChange($event.target.value, '1')"
                :value="settings.selectedSize">
                <option :value="null"></option>
                <option v-for="size in settings.sizes" :key="size.id" :value="size.id" :disabled="size.disabled">
                  {{ size.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- Stone Colors -->
        <div class="selector" v-if="valueObj.values.length > 1" v-for="valueObj in settings.stoneColorObj" :key="valueObj.id">
            <div class="selector-label" style="border-left: none !important">{{$t("stoneColor")}}</div>
            <div class="selector-value">
              <div v-for="stone in valueObj.values" :key="stone.id">
                <img :src="$parent.baseImageUrl + stone.image" height="40" width="40" class="rounded-circle cursor-pointer"
                  v-on:click="settings.triggerToChange(stone.id, 'stone', valueObj.type)" 
                  :style="{border: settings.selectedStoneObj[valueObj.type] == stone.id? '1px solid' : '', opacity: stone.disabled ? '0.2' : '1',}" 
                  :class="{ disableImg: stone.disabled }" v-tooltip.top="{content: stone.label,trigger: 'hover click focus', delay: { show: '200', hide: '500' }}" />
              </div>
            </div>
        </div>

          <!--Stone size-->
          <div class="selector" v-for="objSize in settings.stoneSizeObj" :key="objSize.id">
            <div class="selector-label">{{ $t("choose-carat") }}</div>
            <div class="selector-value">
              <select class="select-setting"
                @change="settings.triggerToChange($event.target.value, 'size', objSize.type)"
                :value="settings.selectedStoneSizeObj[objSize.type]">
                <option :value="null"></option>
                <option v-for="size in objSize.values" :key="size.id" :value="size.id" :disabled="size.disabled">
                  {{ parseFloat(size.label).toFixed(2) }} {{ size.label.includes("X") || size.label.includes("-") ? "
                  mm"
                  : " ct" }}
                </option>
              </select>
            </div>
          </div>

          <!--Engraving-->
          <div class="engraving-selector" v-if="settings.isEngraveVisible">
            <div class="selector">
              <div class="selector-label">{{ $t("customizeEngraving") }}
                (+{{ settings.currentJewelSelection.writingPrice.toFixed(2).replace(".", ",") }}€)</div>
              <div class="selector-value">
                <input class="incisione-checkbox" type="checkbox" :disabled="!$parent.jewelDescription"
                  v-model="settings.incisione" @click="settings.incisioneSelection($event.target.checked)" />

              </div>
            </div>
            <input type="text" class="engraving-input"
              :style="{ border: settings.incisione && !settings.incisioneLabel ? '1px solid red' : '' }"
              :placeholder="$t(`max10Char`, { char: settings.currentCategory ? settings.currentCategory.maxChars || 10 : 10 })"
              v-if="settings.incisione" v-model="settings.incisioneLabel"
              v-on:input="settings.incisioneSelectionLabel()" />
          </div>

          <!--Quantity-->
          <div class="selector">
            <div class="selector-label">{{ $t("quantity") }}</div>
            <div class="selector-value">
              <span class="quantity-selector" @click="changeQuantity(-1)">-</span>
              <span class="quantity-value">{{ $parent.quantity }}</span>
              <span class="quantity-selector" @click="changeQuantity(+1)">+</span>
            </div>
          </div>

          <div v-if="$parent.credential.apiEncryptedUser">
            <textarea v-model="$parent.note" class="item-note" :placeholder="$t('note.placeholder')"></textarea>
          </div>

          <div class="estimated-shipping" v-if="$parent.selectedJewel">
            <div class="estimated-shipping-label">{{ $t("plannedShipment") }}</div>
            <div class="estimated-shipping-value">{{ $parent.selectedJewel.shipmentDate }}</div>
          </div>

          <button class="btn add-to-basket-btn" :class="{ 'disabled': $parent.addedToBasket || !$parent.selectedJewel }"
            :disabled="!$parent.selectedJewel || $parent.addedToBasket || !$parent.jewelDescription || (settings.incisione && !settings.incisioneLabel)"
            v-on:click="$parent.addToBasket">
            <span v-if="$parent.addedToBasket">{{ $t("addedToBasket") }}</span>
            <span v-else>{{ $t("addToBasket") }}</span>
          </button>

          <div class="weigth-alert"
            :title="$parent.selectedSku ? $parent.selectedSku + $parent.additionalSkuLabelArray.join('') : null">
            {{ $t("weigth-alert") }}
          </div>

        </div>
        <div class="col-md-7 order-md-2 order-1">

          <!-- New layout AMA-->

          <div class="row m-0"
            v-if="$parent.jewelDescription && $parent.imagesAvailable.length + $parent.videos.length >= 4 && isDesktop">
            <div v-for="(image, index) in firstGroupImages" class="col-md-6 col-jewel-img-container">
              <div class="jewel-img-container">
                <div class="jewel-img-div">
                  <img :src="$parent.baseImageUrl + image" />
                </div>
                <div class="jewel-img-div-border">
                </div>
              </div>
            </div>
            <div v-for="(video, index) in $parent.videos" class="col-md-6 col-jewel-img-container">
              <div class="jewel-img-container">
                <div class="jewel-img-div">
                  <video ref="videoRef" class="video-container" id="video-container" width="100%"
                    :src="$parent.baseImageUrl + video" muted autoplay loop playsinline></video>
                </div>
                <div class="jewel-img-div-border">
                </div>
              </div>
            </div>
            <div v-for="(image, index) in secondGroupImages" class="col-md-6 col-jewel-img-container">
              <div class="jewel-img-container">
                <div class="jewel-img-div">
                  <img :src="$parent.baseImageUrl + image" />
                </div>
                <div class="jewel-img-div-border">
                </div>
              </div>
            </div>
          </div>

          <div class="row"
            v-if="$parent.jewelDescription && ($parent.imagesAvailable.length + $parent.videos.length < 4 || !isDesktop)">
            <!-- Swiper -->
            <div class="col-12 order-md-2 mb-3"
              :class="{ 'col-md-9': $parent.imagesAvailable.length + $parent.videos.length > 1 }">
              <div>
                <div v-swiper:swiperTop="swiperTopOptions" @slideChange="changeSwiperTopIndex"
                  class="main-swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="image" v-for="(image, index) in firstGroupImages">
                      <img :src="$parent.baseImageUrl + image" class="w-100" />
                    </div>
                    <div class="swiper-slide swiper-slide-video" v-for="video in $parent.videos">
                      <video ref="videoRef" class="video-container" id="video-container" width="100%"
                        :src="$parent.baseImageUrl + video" muted autoplay loop playsinline></video>
                    </div>
                    <div class="swiper-slide" :key="image" v-for="(image, index) in secondGroupImages">
                      <img :src="$parent.baseImageUrl + image" class="w-100" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="$parent.imagesAvailable.length + $parent.videos.length > 1"
              class="col-12 col-md-3 order-md-1 text-left text-md-right pr-0">
              <div ref="swiperThumbs" v-swiper:swiperThumbs="swiperThumbsOptions"
                class="pr-2 pb-2 swiper-thumbs swiper-thumbs-desktop d-md-block">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" :key="image" v-for="(image, index) in firstGroupImages"
                    :class="{ 'active': index == thumbsActiveIndex }">
                    <img :src="$parent.baseImageUrl + image" class="border-img" @click="slideSwiperTopTo(index)" />
                  </div>
                  <div class="swiper-slide"
                    :class="{ 'active': firstGroupImages.length + videoIndex == thumbsActiveIndex }"
                    v-for="(video, videoIndex) in $parent.videos">
                    <img src="../../assets/video-icon.png" class="border-img video-icon"
                      @click="slideSwiperTopTo(firstGroupImages.length + videoIndex)" />
                  </div>
                  <div class="swiper-slide" :key="image" v-for="(image, index) in secondGroupImages"
                    :class="{ 'active': firstGroupImages.length + $parent.videos.length + index == thumbsActiveIndex }">
                    <img :src="$parent.baseImageUrl + image" class="border-img"
                      @click="slideSwiperTopTo(firstGroupImages.length + $parent.videos.length + index)" />
                  </div>
                </div>
                <!-- <div class="swiper-pagination"></div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 order-3 mt-5">
          <related-jewels></related-jewels>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../Breadcrumb.vue';
import { mapState, mapGetters } from 'vuex';
import RelatedJewels from '../RelatedJewels.vue';

export default {
  name: "DetailAma",
  components: {
    Breadcrumb,
    RelatedJewels
  },
  directives: {
  },
  data() {
    return {
      isMounted: false,
      thumbsActiveIndex: 0,
      swiperTopOptions: {
        slidesPerView: 1,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // Some Swiper option/callback...
      },
      isDesktop: window.innerWidth > 768,
      swiperThumbsOptions: {
        slidesPerView: 'auto',
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: "5"
          }
        },
        direction: (window.innerWidth > 768 ? 'vertical' : 'horizontal'),
        height: "80px",
      },
      readMore: false
    }
  },
  computed: {
    ...mapState("config", ["showOnlyPublicPrice"]),
    settings() {
      if (!this.isMounted)
        return {};
      return this.$parent.$refs.ringSettings
    },
    firstGroupImages: function () {
      //-X- identifica le foto dell'indossato
      return this.$parent.imagesAvailable.filter((image, index) => {
        return index == 0 || image.includes("-X-");
      });
    },
    secondGroupImages: function () {
      //-X- identifica le foto dell'indossato
      return this.$parent.imagesAvailable.filter((image, index) => {
        return index != 0 && !image.includes("-X-");
      });
    }
  },
  mounted() {
    this.isMounted = true;
    this.$parent.note = null;
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    changeQuantity(value) {
      if (this.$parent.quantity + value < 1)
        return;
      this.$parent.quantity += value;
      this.$parent.changeQuantity();
    },
    changeSwiperTopIndex() {
      this.thumbsActiveIndex = this.swiperTop.activeIndex
      this.swiperThumbs.slideTo(this.swiperTop.activeIndex);
      this.swiperThumbs.updateActiveIndex(this.swiperTop.activeIndex);
    },
    resetSwiperIndex() {
      this.swiperTop && (this.swiperTop.activeIndex = 0);
      this.swiperThumbs && (this.swiperThumbs.activeIndex = 0);
      this.swiperTop && (this.thumbsActiveIndex = this.swiperTop.activeIndex);
    },
    slideSwiperTopTo(index) {
      this.swiperTop.slideTo(index);
    },
    onResize() {
      this.isDesktop = window.innerWidth > 768;
      let direction = this.isDesktop ? 'vertical' : 'horizontal';
      this.swiperThumbs && !this.swiperThumbs.destroyed && this.swiperThumbs.changeDirection(direction);
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.customize-your-jewel {
  font-size: 2.5rem;
  font-family: var(--font-family-reckless-italic);
  margin-bottom: 30px;
  margin-top: 30px;
  text-align: left;
}

.model-name {
  font-weight: bold;
  font-size: 23px;
}

.wholesale-price {
  display: flex;
  font-size: 18px;
  padding-top: 20px;

  .wholesale-price-label {
    font-weight: bold;
    width: 100%;
    padding-right: 5px;
  }

  .wholesale-price-value {
    font-weight: bold;
    width: 100%;
  }
}

.retail-price {
  display: flex;
  margin-top: 5px;
  margin-bottom: 25px;

  .retail-price-label {
    width: 100%;
    padding-right: 5px;
  }

  .retail-price-value {
    width: 100%;
  }
}

.engraving-selector {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;

  .selector {
    border: 0;
    margin-bottom: 0px;
  }
}

.selector {
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;

  .selector-label {
    width: 100%;
    padding-right: 5px;
  }

  .selector-value {
    display: flex;
    text-align: right;
  }
}

.estimated-shipping {
  display: flex;
  margin-top: 30px;
  font-size: 12px;

  .estimated-shipping-label {
    width: 100%;
    padding-right: 5px;
  }

  .estimated-shipping-value {
    width: 100%;
    text-align: right;
  }
}

.gold-circle {
  cursor: pointer;
  height: 25px;
  display: inline-block;
  margin-right: 5px;

  img {
    height: 100%;
    border-radius: 100%;
  }
}

.quantity-selector {
  cursor: pointer;
}

.quantity-value {
  padding: 0px 5px;
  font-weight: bold;
}

#app button.add-to-basket-btn {
  background-color: var(--ama-green);
  color: var(--ama-white);
  font-family: var(--font-family-reckless-italic);
  width: 100%;
  margin-top: 5px;
  cursor: pointer;
}

.jewel-description {
  font-family: var(--font-family-reckless);
  margin-top: 5px;
}

.read-more-value {
  font-family: var(--font-family-reckless);
  font-size: 14px;
}

.read-more {
  margin-bottom: 25px;
}

.read-more-label {
  margin-bottom: 5px;
  font-family: var(--font-family-reckless-italic);
  font-weight: bold;
  text-decoration: underline;
  font-size: 13px;
  cursor: pointer;
}

.weigth-alert {
  font-size: 12px;
  margin-top: 20px;
}

.col-jewel-img-container {
  padding: 5PX;

  &:nth-child(1) {
    .jewel-img-div {
      clip-path: polygon(1% 1%, 70% 1%, 99% 30%, 99% 99%, 30% 99%, 1% 70%);
    }

    .jewel-img-div-border {
      clip-path: polygon(0 0, 70% 0, 100% 30%, 100% 100%, 30% 100%, 0 70%);
    }
  }

  &:nth-child(2) {
    .jewel-img-div {
      clip-path: polygon(30% 1%, 99% 1%, 99% 70%, 70% 99%, 1% 99%, 1% 30%);
    }

    .jewel-img-div-border {
      clip-path: polygon(30% 0, 100% 0, 100% 70%, 70% 100%, 0 100%, 0 30%);
    }
  }

  &:nth-child(3) {
    .jewel-img-div {
      clip-path: polygon(30% 1%, 99% 1%, 99% 99%, 1% 99%, 1% 30%)
    }

    .jewel-img-div-border {
      clip-path: polygon(30% 0, 100% 0, 100% 100%, 0 100%, 0 30%);
    }

  }

  &:nth-child(4) {
    .jewel-img-div {
      clip-path: polygon(1% 1%, 70% 1%, 99% 30%, 99% 99%, 99% 99%, 1% 99%);
    }

    .jewel-img-div-border {
      clip-path: polygon(0 0, 70% 0, 100% 30%, 100% 100%, 100% 100%, 0 100%);
    }
  }


  & {
    .jewel-img-div {
      clip-path: polygon(1% 1%, 99% 1%, 99% 30%, 99% 99%, 30% 99%, 1% 99%);
    }

    .jewel-img-div-border {
      clip-path: polygon(0 0, 100% 0, 101% 30%, 100% 100%, 30% 101%, 0 100%);
    }
  }
}

.jewel-img-container {
  position: relative;
  padding: 0;
  height: 100%;
}

.jewel-img-div {
  position: absolute;
  background: white;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;

  img {
    max-height: 100%;
    max-width: 100%;
  }

}

.jewel-img-div-border {
  background-color: var(--ama-gray);
  padding: 50%;
  height: 100%;

  img {
    max-height: 100%;
    max-width: 100%;
  }
}

.main-swiper-container {
  width: 100%;
  box-shadow: 0px 2px 5px 0px #707070;
  overflow: hidden;
}

.border-img {
  box-shadow: 0px 2px 5px 0px #707070;
}

.swiper-thumbs-desktop {

  .swiper-slide {
    padding-bottom: 5px;
    width: auto;
    padding: 3px;

    .border-img {
      height: 80px;
    }

    .video-icon {
      padding: 25px;
    }
  }
}

.video-container {
  display: block;
  height: 100%;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;

}

.swiper-thumbs {
  .swiper-slide {
    opacity: 0.5;

    &.active {
      opacity: 1;
    }
  }
}

.swiper-slide-video {
  flex-grow: 1;
  height: unset;
}

.engraving-input {
  display: block;
  width: 100%;
  font-size: 14px;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .model-name {
    font-size: 18px;
  }

  .wholesale-price {
    font-size: 15px;
  }

  .retail-price {
    font-size: 14px;
  }
}

@media only screen and (min-width: 0px) and (max-width: 768px) {
  .model-name {
    font-size: 18px;
  }

  .selector-label {
    font-size: 14px;
  }

  .customize-your-jewel {
    font-size: 25px;
    text-align: center;
  }

  .wholesale-price {
    font-size: 15px;

    .wholesale-price-label {
      margin-right: 10px;
    }
  }

  .retail-price {
    font-size: 14px;

    .retail-price-label {
      margin-right: 10px;
    }
  }
}

.item-note {
  width: 100%;
  font-size: 14px;
  padding: 4px;
}

.model-sku {
  font-size: 14px;
  margin: 5px 0px;
}

</style>
